export default "__VITE_ASSET__CfR0OSaQ__"